import { Injectable, inject } from '@angular/core';
import { Firestore, collection, deleteDoc, doc, getDocs, query, setDoc, updateDoc, where } from '@angular/fire/firestore';
import { NetworkConstants } from 'na-lib';
import { CommentsService } from './comments.service';
import { SettingsService } from './settings.service';
import { removeUndefinedValuesFromObject } from 'na-lib';
import { from, map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserGroupService {
  db = inject(Firestore)
  settingsUserGroups:any=[]

  constructor(private commentsService:CommentsService,
    private settingsService:SettingsService) { }

  async createUserGroup(userGroup:any, ):Promise<string>{
    return new Promise(async (resolve,reject)=> {
      try{
        this.commentsService.progressSpin.emit(true)

        const docRef = doc( collection(this.db, NetworkConstants.COLLECTION_USER_GROUPS) )
        const newid = docRef.id

        let newUserGroup = userGroup
        newUserGroup['contextId'] =  this.settingsService.contextId$
        // newUserGroup['id'] = docRef.id
        newUserGroup['creationDate'] = new Date()
        newUserGroup['timeStamp'] = new Date()

        await setDoc( docRef, newUserGroup)

        resolve({id:newid, ...newUserGroup})
        this.commentsService.progressSpin.emit(false)

      }catch(error){
        this.commentsService.progressSpin.emit(false)
        reject(error)
        console.log(error)
      }
    })
  }

  updateUserGroup(userGroup:any, id): Promise<any>{
    return new Promise(async (resolve,reject)=> {
      const data = removeUndefinedValuesFromObject(userGroup)
     
      try{
        delete data['id']
        data['contextId'] =  this.settingsService.contextId$
        data['timeStamp'] = new Date()
        const docRef = doc(this.db, NetworkConstants.COLLECTION_USER_GROUPS, id)
        await updateDoc( docRef, userGroup)

        resolve(data)
      }
      catch(error){
        reject(error)
        console.log(error)
      }
    })
  }

  deleteUserGroup(userGroupId:any){
    return new Promise(async (resolve, reject) => {
      try {
        const docRef = doc(this.db, NetworkConstants.COLLECTION_USER_GROUPS, userGroupId)
        const d  = await deleteDoc( docRef)
        resolve(d)
      } catch (error) {
        reject(error)  
        console.log(error)      
      } 
    })
  }

  observeContextsUserGroupsFirestoreWithId(){
    this.settingsUserGroups = []

    const contextId = this.settingsService.contextId$
    const ref = collection(this.db, NetworkConstants.COLLECTION_USER_GROUPS);
    const q = query(ref, where('contextId', '==', contextId));

    return from(getDocs(q)).pipe(
      map(snapshot =>
        snapshot.docs.map(doc => ({ id: doc.id, ...(doc.data() as any) }))
      ),
      tap(items => {
        this.settingsUserGroups = items
      }),
    );

  }

}
